<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>

  <div class="bg-white bottom-page-shadow rounded-bottom-extra mx-1">
    <div class="row ps-3">
      <div class="col pt-3 ">
        <p> <span class="fw-bold">Pembayar Cukai</span> - Status e-Borang </p>
      </div>
    </div>
    <div class="row">
      <div class="col pt-3 mx-5 ">
        <p class="text-muted">Sila pilih status e-Borang dan kriteria carian.</p>
      </div>
    </div>
    <div class="row pb-2">
      <div class="col-2 ms-5 me-2">
        <select class="form-select border-0 shadow" [(ngModel)]="FormStatusInput" [ngModelOptions]="{standalone: true}">
          <option value="">Status e-Borang</option>
          <option value="true">Hantar</option> <!--kamilah-->
          <option value="false">Belum Hantar</option> <!--kamilah-->
          <!-- <option value="3">No. Pendaftaran (ROC)</option> -->
        </select>
      </div>
      <div class="col-2 mx-2">
        <!--asad tambah 17.1.2024-->
        <select class="form-select border-0 shadow" [disabled]="isSelectDisabled" [(ngModel)]="YearAssessmentInput" [ngModelOptions]="{standalone: true} ">
          <option value="">Tahun Taksiran</option>
          <option value="2027">2027</option>
          <option value="2026">2026</option>
          <option value="2025">2025</option>
          <option value="2024">2024</option>
          <option value="2023">2023</option>
          <option value="2022">2022</option>
          <option value="2021">2021</option>
          <option value="2020">2020</option>
          <option value="2019">2019</option>
          <option value="2018">2018</option>
          <option value="2017">2017</option>
          <option value="2016">2016</option>
          <option value="2015">2015</option>
          <option value="2014">2014</option>
          <option value="2013">2013</option>
          <option value="2012">2012</option>
        </select>
      </div>
      <div class="col-5">
        <div class="btn-toolbar d-flex justify-content-center">
          <div class="me-2">
            <button type="button" class="btn submit-button border-0 shadow rounded-2" role="button" (click)="Submit(FormStatusInput,IDTypeInput,IDNoInput,YearAssessmentInput)">Hantar</button>
          </div>
          <div class="me-2">
            <button type="button" class="btn sec-button border-0 shadow rounded-2" role="button" (click)="Semula()">Semula</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row pb-5 ">
      <div class="col-2 ms-5 me-2">
        <!--asad ubah 17.1.2024-->
        <select class="form-select border-0 shadow" [(ngModel)]="IDTypeInput" [ngModelOptions]="{standalone: true}" (change)="onChangeIDType(IDTypeInput)">
          <option value="" selected>Jenis Carian</option>
          <option value="1">MyKad/MyPR/MyKAS</option>
          <option value="2">No. Pasport/Dokumen lain</option>
          <!-- <option value="3">Tentera</option>
          <option value="4">Polis</option> -->
          <option value="5">No. Pendaftaran</option>
          <option value="6">TIN (Selain Majikan)</option>
          <option value="7">TIN (Majikan)</option>
          <option value="8">No. Pengenalan Pengguna Firma</option>
        </select>
      </div>


      <div class="col-2 ms-2" *ngIf="IDTypeInput === '6'">
        <input type="number" class="form-control border-0 shadow" [(ngModel)]="IDNoInput" [ngModelOptions]="{standalone: true}">
      </div>
      <div class="col-2 ms-2" *ngIf="IDTypeInput !== '6'">
        <input type="text" class="form-control border-0 shadow" [(ngModel)]="IDNoInput" [ngModelOptions]="{standalone: true}">
      </div>
    </div>

    <!--asad tambah 30.4.2024-->
    <div class="col-4 ms-5 me-2" *ngIf="InfoStatus">
      <span class="info-icon black-text">
        <i class="fas fa-info-circle"></i> <!-- Assuming you're using Font Awesome for icons -->
        Carian atas no. pengenalan pengguna firma merujuk kepada senarai borang yang dipegang oleh Pengguna Firma (Ejen Cukai/ Penyelia / Staf).
      </span>
      <div>

      </div>
    </div>

    <div class="mx-5 px-3 pb-5" *ngIf="SearchStatus">
      <div>
        <p>Senarai Pembayar Cukai</p>
        <!-- <mat-form-field>
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Ex. ium" #input>
        </mat-form-field>  -->
        <!--<input #input type="text" (keyup)="applyFilter($event)" class="form-control w-25 mb-2 border-0 shadow" placeholder="Carian" aria-label="Carian" aria-describedby="basic-addon1">-->
      </div>
      <div class="example-table-container">
        <table mat-table [dataSource]="dataSource" class="w-100 shadow">
          <ng-container matColumnDef="pembayarcukai">
            <th class="text-start primary-colour" mat-header-cell *matHeaderCellDef>Pembayar Cukai</th>
            <td class="text-start" mat-cell *matCellDef="let res">{{res.name}}</td>
          </ng-container>
          <ng-container matColumnDef="jenisborang">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Jenis Borang</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.namaBorang}}</td>
          </ng-container>
          <ng-container matColumnDef="tin">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>TIN</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.tin}}</td>
          </ng-container>
          <ng-container matColumnDef="caw">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>LHDNM / Cawangan Khas</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.branchName}}</td>
          </ng-container>
          <ng-container matColumnDef="tarikhdaftar">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tarikh Daftar</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.dateRegistered}}</td>
          </ng-container>
          <ng-container matColumnDef="tarikhhantar">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tarikh Hantar</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.dateSubmitted}}</td>
          </ng-container>
          <ng-container matColumnDef="namastaf">
            <th class="text-start primary-colour" mat-header-cell *matHeaderCellDef>Nama Staf</th>
            <td class="text-start" mat-cell *matCellDef="let res">{{res.staffName}}</td>
          </ng-container>
          <ng-container matColumnDef="namaejen">
            <th class="text-start primary-colour" mat-header-cell *matHeaderCellDef>Nama Ejen</th>
            <td class="text-start" mat-cell *matCellDef="let res">{{res.agentName}}</td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tindakan</th>
            <td mat-cell *matCellDef="let res">
              <div class="btn-toolbar d-flex justify-content-center">
                <div class="me-2" *ngIf="res.distributeAccess" [ngClass]="res.status !== 'Belum Hantar' ? 'd-none' : ''">
                  <button (click)="DistributeShow(res.taxReturnFormID,res.staffID,res.name,res.formType,res.agentID,res.agentName,res.tin,res.dateRegistered,res.dateSubmitted,res.staffName,res.namaBorang)" type="button" class="btn sec-button border-0 shadow rounded-2" role="button" data-bs-toggle="modal" data-bs-target="#agihSemulaModal">Agih Semula</button>
                </div>
                <div class="me-2" *ngIf="res.acknowledgementAccess" [ngClass]="res.status === 'Belum Hantar' ? 'd-none' : ''">
                  <button type="button" class="btn sec-button border-0 shadow rounded-2" role="button" (click)="GetAcknowledment(res.formType,res.formYear,res.tin)">Semakan</button>
                </div>
                <div class="me-2" *ngIf="res.jenis_Borang == 'CKM'">
                  <button type="button" class="btn sec-button border-0 shadow rounded-2" data-bs-toggle="modal" data-bs-target="#ckmSemakanModal" role="button" (click)="CKMAcknowledgementValueSet(res.tin)">Semakan</button>
                </div>
                <div class="me-2" *ngIf="res.resetAccess">
                  <button type="button" class="btn sec-button border-0 shadow rounded-2" role="button" data-bs-toggle="modal" data-bs-target="#setSemulaModal" (click)="ResetFormValue(res.tin,res.formType,res.formYear)">Set Semula</button>
                </div>
                <div class="me-2" *ngIf="res.loginAccess" [ngClass]="res.status !== 'Belum Hantar' ? 'd-none' : ''">
                  <button type="button" class="btn sec-button border-0 shadow rounded-2" role="button" (click)="LoginForm(res.taxReturnFormID,res.formType,res.tin)">Login</button>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let res;columns:displayedColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center" colspan="8">Tiada Rekod</td>
          </tr>
        </table>
        <mat-paginator class="mat-evelation-z8" (page)="paginatorEvent($event)" [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[10,15,20]" [length]="RecordCount">
        </mat-paginator>
      </div>
    </div>
  </div>
</div>

<!-- Agih Semula Modal -->
<div class="modal fade" id="agihSemulaModal" tabindex="-1" aria-labelledby="agihSemulaModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>

        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>Agih Semula</p>
          </div>
        </div>
        <div class="row rounded-bottom-extra shadow mx-3" style="background-color: #F5F5F5 !important;">
          <div class="col m-3">
            <div class="row">
              <div class="col-2">
                <p>Pembayar Cukai</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p><strong>{{NameView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <p>Jenis Borang</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p><strong>{{FormTypeView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <p>Nama Ejen</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p class="text-uppercase"><strong>{{TaxAgentNameView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <p>TIN</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p class="text-uppercase"><strong>{{TaxRefNumView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <p>Tarikh Daftar</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p class="text-uppercase"><strong>{{RegisterDateView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <p>Tarikh Hantar</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p class="text-uppercase"><strong>{{SubmittedDateView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <p>Nama Staf</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p class="text-uppercase"><strong>{{StaffNameView}}</strong></p>
              </div>
            </div>

            <div class="row py-5">
              <div class="col-2">
                <p>Agih Kepada</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <select class="form-select border-0 shadow" [(ngModel)]="DistributeInput" [ngModelOptions]="{standalone: true}">
                  <option value="">Senarai Staf</option>
                  <option *ngFor="let res of DistributeList" [value]="res.staffID">{{res.staffName}}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col d-flex justify-content-end align-items-end">
                <div class="btn-toolbar">
                  <div class="me-2">
                    <button data-bs-dismiss="modal" (click)="DistributeSubmit(DistributeInput,TaxReturnFormIDView,TaxRefNumView,FormTypeView,TaxAgentIDView)" type="button" class="btn submit-primary-button border-0 shadow rounded-2" role="button">Agih Semula</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Semakan Modal -->
<!--<div class="modal fade" id="semakanModal" tabindex="-1" aria-labelledby="semakanModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content" style="background-color: rgba(223, 224, 224, 0.9);border-radius: 1.7rem !important;">
      <div class="modal-body">-->
<!-- <div class="d-flex justify-content-end align-items-end">
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div> -->
<!--<div class="d-flex justify-content-center align-items-center">
          <img src="./assets/icons/paper-pencil-yellow-circle.svg" height="90" width="90" alt="..." />
        </div>
        <p class="fw-bold text-center">Adakah anda pasti untuk membuat Semakan?</p>
        <div class="d-flex justify-content-center align-items-center pb-3 pt-3">
          <div class="d-block">
            <button class="btn button-white-table shadow" style="height: 35px; width: 102px" type="button" data-bs-dismiss="modal">Tidak</button>
            <button class="btn button-white-table shadow mx-3" style="height: 35px; width: 102px" type="button" data-bs-dismiss="modal">Ya</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>-->
<!-- Set Semula Modal -->
<div class="modal fade" id="setSemulaModal" tabindex="-1" aria-labelledby="setSemulaModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content" style="background-color: rgba(223, 224, 224, 0.9);border-radius: 1.7rem !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-center align-items-center">
          <img src="./assets/icons/paper-pencil-yellow-circle.svg" height="90" width="90" alt="..." />
        </div>
        <p class="fw-bold text-center">Adakah anda pasti untuk membuat Set Semula?</p>
        <div class="d-flex justify-content-center align-items-center pb-3 pt-3">
          <div class="d-block">
            <button class="btn button-white-table shadow" style="height: 35px; width: 102px" type="button" data-bs-dismiss="modal">Tidak</button>
            <button class="btn button-white-table shadow mx-3" style="height: 35px; width: 102px" type="button" data-bs-dismiss="modal" (click)="ResetForm(TaxRefNumResetForm,FormTypeResetForm,YearAssessmentResetForm)">Ya</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- CKM Acknowledgement Modal -->
<div class="modal fade" id="ckmSemakanModal" tabindex="-1" aria-labelledby="ckmSemakanModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>
        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>CKM Semakan Pengesahan</p>
          </div>
        </div>
        <div class="row rounded-bottom-extra shadow mx-3" style="background-color: #F5F5F5 !important;">
          <div class="col m-3">
            <div class="row py-5">
              <div class="col-3">
                <p>Tahun Taksiran</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-4">
                <select class="form-select border-0 shadow" [(ngModel)]="CKMYearAssessmentInput" [ngModelOptions]="{standalone: true}">
                  <option value="">Tahun</option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col d-flex justify-content-end align-items-end">
                <div class="btn-toolbar">
                  <div class="me-2">
                    <button data-bs-dismiss="modal" type="button" class="btn submit-primary-button border-0 shadow rounded-2" role="button" (click)="GetAcknowledment('CKM',CKMYearAssessmentInput,TaxRefNumView)">Hantar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
